import React from 'react';
import { IconProps } from './type';

export const DigitalSampleIcon = ({
  color = '#3499CC',
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      {...props}
    >
      <mask id="path-1-inside-1_5795_54805" fill="white">
        <rect x="2.5" y="2.8999" width="12" height="8" rx="0.5" />
      </mask>
      <rect
        x="2.5"
        y="2.8999"
        width="12"
        height="8"
        rx="0.5"
        stroke={color}
        strokeWidth="2.4"
        mask="url(#path-1-inside-1_5795_54805)"
      />
      <path
        d="M1.5 12.2C1.5 12.0895 1.58954 12 1.7 12H15.3C15.4105 12 15.5 12.0895 15.5 12.2V12.2931C15.5 12.3688 15.4572 12.4381 15.3894 12.4719L14.3756 12.9789C14.3478 12.9928 14.3172 13 14.2861 13H2.71388C2.68283 13 2.65221 12.9928 2.62444 12.9789L1.61056 12.4719C1.5428 12.4381 1.5 12.3688 1.5 12.2931V12.2Z"
        fill={color}
      />
    </svg>
  );
};
